__turbopack_context__.v({
  "button": "_3a0pW_button",
  "destructive": "_3a0pW_destructive",
  "footer": "_3a0pW_footer",
});
